var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApptNoteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14058_70069)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 44,
    height: 44,
    rx: 7.33333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.45833,
    y: 1.45833,
    width: 43.0833,
    height: 43.0833,
    rx: 6.875,
    stroke: "#E9EAEB",
    strokeWidth: 0.916667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6946 28.0708V15.1626C34.6946 13.8793 33.6465 12.9275 32.3739 13.0344H32.3097C30.0639 13.2269 26.6523 14.3712 24.7487 15.569L24.5669 15.6867C24.2568 15.8792 23.7434 15.8792 23.4333 15.6867L23.1659 15.5262C21.2623 14.3392 17.8615 13.2055 15.6157 13.0237C14.343 12.9168 13.3057 13.8793 13.3057 15.1519V28.0708C13.3057 29.0975 14.1398 30.06 15.1665 30.1883L15.4766 30.2311C17.7973 30.5412 21.38 31.7176 23.4333 32.8405L23.4761 32.8619C23.7648 33.0224 24.2247 33.0224 24.5027 32.8619C26.5561 31.7283 30.1494 30.5412 32.4808 30.2311L32.8337 30.1883C33.8604 30.06 34.6946 29.0975 34.6946 28.0708Z",
    stroke: "#51439E",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 16.0391V32.0807",
    stroke: "#51439E",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4546 19.25H17.0483",
    stroke: "#51439E",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2567 22.457H17.0483",
    stroke: "#51439E",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14058_70069",
    x: 0.166667,
    y: 0.0833333,
    width: 47.6667,
    height: 47.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.916667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.916667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0496732 0 0 0 0 0.0705882 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14058_70069"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14058_70069",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApptNoteIcon);
export default __webpack_public_path__ + "static/media/apptNoteIcon.5420397d107e8ab2374701617ae19db9.svg";
export { ForwardRef as ReactComponent };